<template>
  <div>
    <div class="sticky-top">
      <div class="card m-b-0">
        <div class="card-body text-right m-r-30">
          <a
            :href="`${story.canonical_url}/${previewToken}/`"
            target="_blank"
            class="btn btn-outline btn-sm m-r-10"
          >
            <i class="fa fa-external-link"></i>
            Voir la page
          </a>
          <router-link
            :to="{
              name: 'story',
              params: { id: $route.params.id },
              query: { edit: true }
            }"
            class="btn btn-outline btn-sm m-r-10"
          >
            <i class="fa fa-chevron-circle-left"></i>
            Retour
          </router-link>
          <a href @click.prevent="saveStory()" class="btn btn-primary">
            <i class="fa fa-save"></i>
            Enregistrer
          </a>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="container-fluid">
        <transition name="fade" mode="out-in">
          <div class="row">
            <div class="col-lg-8">
              <div class="card" v-loading="loading">
                <div class="card-body">
                  <el-form label-position="right" size="medium">
                    <el-form-item>
                      <el-input
                        placeholder="Titre de l’article"
                        @input="updateStoryAttribute('title', $event)"
                        :value="story.title"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="Extrait">
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 6 }"
                        maxlength="242"
                        show-word-limit
                        placeholder="Extrait"
                        @input="updateStoryAttribute('extract', $event)"
                        :value="story.extract"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="Chapô">
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 6 }"
                        placeholder="Chapô"
                        @input="updateStoryAttribute('headline', $event)"
                        :value="story.headline"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="Coulisses">
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 6 }"
                        placeholder="Coulisses"
                        @input="updateStoryAttribute('backstage', $event)"
                        :value="story.backstage"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                  <hr />
                  <FluxEditor
                    v-if="editable"
                    ref="rte"
                    :options="FuxEditorOptions"
                    :content="editable"
                  ></FluxEditor>
                </div>
                <!-- <pre>{{ constants }}</pre> -->
                <!-- <pre>{{ story }}</pre> -->
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <div class="card m-b-0">
                  <div class="card-header">
                    <h2 class="h4 m-b-5 m-t-5">
                      Pièces jointes
                    </h2>
                  </div>
                  <div class="card-body">
                    <StoryEditorAttachments></StoryEditorAttachments>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <el-drawer
      title="Sélectionnez l’illustration"
      ref="imageDrawerWidget"
      :withHeader="false"
      :visible.sync="imageDrawer"
      size="50%"
    >
      <div class="m-l-20">
        <h3>
          Insérer une image
        </h3>
        <div class="row">
          <div
            v-if="attachment.meta.type && attachment.meta.type == 'image'"
            v-for="attachment in story.attachments"
            class="col-md-3"
          >
            <a
              href
              @click.prevent="
                insertRTEImage(
                  `${$env.VUE_APP_STATIC_BASE_URL}/attachments/${
                    story.folder_uri
                  }${attachment.value}`
                )
              "
            >
              <el-image
                style="width: 120px; height: 120px"
                :src="
                  `attachments/${story.folder_uri}${attachment.value}`
                    | static_url
                "
                fit="contain"
              ></el-image>
            </a>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      title="Rechercher un article"
      ref="storyDrawerWidget"
      :withHeader="false"
      :visible.sync="storyDrawer"
      size="50%"
    >
      <div
        v-loading="storyDrawerLoading"
        class="m-l-20 m-r-20 overflow-auto vh-100"
      >
        <h3>
          Rechercher un article
        </h3>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <el-input
              autosize
              ref="storyTerm"
              placeholder="Filtrer par mots clés (titre)"
              @keyup.enter.native="storiesFilter()"
              @change="storiesFilter()"
              v-model="storyDrawerTerm"
            ></el-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div>
              <table class="table table-hover">
                <tbody>
                  <tr v-for="story in storyDrawerStories" class="pointer">
                    <td @click="storyDrawerSelectStory(story)">
                      <el-image
                        style="width: 70px; height: 70px"
                        :src="story.thumb_story_list_url"
                        fit="contain"
                      ></el-image>
                    </td>
                    <td @click="storyDrawerSelectStory(story)">
                      <h5
                        class="m-b-10"
                        :class="{ 'text-muted': !story.title }"
                      >
                        {{ story.title || "Aucun titre" }}
                        <br />
                        <small>
                          <i
                            v-if="story.scheme == 'VIDEO'"
                            class="fa fa-television"
                          ></i>
                          <i
                            v-if="story.scheme == 'STORY'"
                            class="fa fa-file-text-o"
                          ></i>
                          <span
                            :class="{
                              'badge-success': story.status == 'PUBLISHED',
                              'badge-danger': story.status == 'DISABLED'
                            }"
                            class="badge m-l-5 m-r-5"
                          >
                            {{ story.status | translate }}
                          </span>
                          <span v-if="story.authors.length > 0">
                            par
                            <span v-for="author in story.authors">
                              {{ author.screenname }}
                            </span>
                          </span>
                          - créé {{ story.created_at | fromNowDate }} - publié
                          le
                          {{
                            story.published_at
                              | formatDate("DD/MM/YYYY à HH:mm")
                          }}
                          <span
                            v-if="
                              story.primary_category &&
                                story.primary_category.label
                            "
                          >
                            -
                            <span>
                              <i class="fa fa-folder-o"></i>
                              {{ story.primary_category.label }}
                            </span>
                          </span>
                        </small>
                      </h5>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import StoryEditorAttachments from "./StoryEditorAttachments.vue";

export default {
  computed: mapGetters({
    constants: "constants",
    story: "story"
  }),
  components: {
    StoryEditorAttachments
  },
  data() {
    let _this = this;
    return {
      loading: false,
      edit: false,
      imageDrawer: false,
      insertNewImageContext: null,
      storyDrawer: false,
      storyDrawerLoading: false,
      storyDrawerTerm: "",
      storyDrawerStories: [],
      insertNewStoryContext: null,
      previewToken: null,
      mask:
        "id,title,canonical_url,extract,headline,backstage,content,attachments,folder_uri",
      editable: null,
      FuxEditorOptions: {
        plugins: {
          FluxEditorText: {
            active: true,
            events: {}
          },
          FluxEditorList: {
            active: true,
            events: {}
          },
          FluxEditorTwitter: {
            active: true
          },
          FluxEditorImage: {
            active: true,
            events: {
              onNewElement(args) {
                _this.imageDrawer = true;
                _this.insertNewImageContext = args;
              }
            }
          },
          FluxEditorVideo: {
            active: true
          },
          FluxEditorStory: {
            active: true,
            events: {
              onNewElement(args) {
                _this.storyDrawer = true;
                _this.insertNewStoryContext = args;
                _this.focusEl();
              }
            }
          }
        }
      }
    };
  },
  watch: {
    $route(to, from) {
      this.edit = JSON.parse(to.query.edit);
      this.init();
    }
  },
  created() {
    this.init();
  },
  methods: {
    focusEl() {
      this.$nextTick(() => {
        this.$refs.storyTerm.$el.focus();
      });
    },
    init() {
      this.loading = true;
      this.$sidebar.displaySidebar(false);
      if (this.$route.query.edit) {
        this.edit = this.$route.query.edit;
      }
      this.$store
        .dispatch("getStory", {
          id: this.$route.params.id,
          headers: {
            "X-Fields": this.mask
          }
        })
        .then(() => {
          this.loading = false;
          if (!this.story.content) {
            this.editable = "<p></p>";
          } else {
            this.editable = this.story.content;
          }
          this.getPreviewToken();
        });
    },
    updateStoryAttribute(key, value) {
      let data = {
        [key]: value
      };
      this.$store.commit("UPDATE_STORY_VALUE", data);
    },
    saveStory() {
      this.loading = true;
      this.updateStoryAttribute(
        "content",
        this.$refs.rte.fluxEditorInstance.getHTML()
      );
      return this.$store
        .dispatch("saveStory", {
          headers: {
            "X-Fields": this.mask,
            "X-UpdateKeys":
              "title,extract,headline,backstage,content,updated_at"
          }
        })
        .then(() => {
          this.loading = false;
          this.$message({
            type: "success",
            message: "Enregistrement effectué avec succès"
          });
          this.getPreviewToken();
        });
    },
    insertRTEImage(src) {
      // console.log(src)
      // console.log(this.insertNewImageContext)
      // console.log(this.$env)
      // console.log(JSON.parse(JSON.stringify(this.$env)))
      this.insertNewImageContext.plugin.insertNewElement(
        {
          src: src,
          caption: "",
          accessibility: this.story.title
        },
        this.insertNewImageContext.fluxElementIndex,
        this.insertNewImageContext.core
      );
      this.$refs.imageDrawerWidget.closeDrawer();
      const el = document.body;
      el.style = null;
    },
    storyDrawerSelectStory(story) {
      this.insertNewStoryContext.plugin.insertNewElement(
        {
          heading: story.title,
          excerp: story.headline_or_extract_short,
          image: story.thumb_hero_url,
          canonical_url: story.canonical_url
        },
        this.insertNewStoryContext.fluxElementIndex,
        this.insertNewStoryContext.core
      );
      this.$refs.storyDrawerWidget.closeDrawer();
      const el = document.body;
      el.style = null;
    },
    storiesFilter() {
      let _this = this;
      if (this.storyDrawerTerm) {
        this.storyDrawerLoading = true;
        this.axios
          .get("/stories/", {
            params: {
              term: this.storyDrawerTerm,
              scope: "PUBLIC",
              per_page: 100
            },
            headers: {
              "x-fields":
                "id,slug,title,extract,headline_or_extract_short,status,thumb_story_list_url,scheme,created_at," +
                "thumb_hero_url,canonical_url,published_at,primary_category{label,scheme}" +
                "authors{id,screenname}"
            }
          })
          .then(response => {
            this.storyDrawerStories = response.data.results;
            this.storyDrawerLoading = false;
          });
      }
    },
    getPreviewToken() {
      return this.axios.post("/auth/forge-token/").then(response => {
        this.previewToken = response.data.results.token;
      });
    }
  }
};
</script>
<style>
.flux-story {
  border: 1px solid #aaa;
  margin: 20px 10%;
  padding: 20px;
}

.flux-story-link {
  color: inherit;
}

.flux-story-image {
  margin-bottom: 10px;
}

.flux-story-heading {
  margin-bottom: 5px;
}

.flux-story-heading {
  font-weight: bold;
}
</style>
